import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/services";

// Collecte tous les chantiers avec photos, tagués par expertise
const ALL_REFERENCES = SERVICES.flatMap((s) =>
  (s.references || [])
    .filter((r) => (r.images && r.images.length > 0) || r.image)
    .map((r) => ({
      ...r,
      serviceSlug: s.slug,
      serviceTitle: s.title,
    }))
);

export default function Realisations() {
  if (ALL_REFERENCES.length === 0) return null;

  return (
    <section
      id="realisations"
      data-testid="realisations-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 mb-14 items-end">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-4">
              <span className="inline-block w-10 h-px bg-[#FF5A1F]" />
              <span className="label-kicker text-[#FF5A1F]">Réalisations</span>
            </div>
            <h2
              data-testid="realisations-title"
              className="font-display font-extrabold text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#0F172A] leading-[1]"
            >
              Des chantiers qui parlent
              <br /> pour nous.
            </h2>
          </div>
          <p className="lg:col-span-5 text-base md:text-lg text-slate-600 leading-relaxed">
            Quelques réalisations récentes en Île-de-France. Cliquez sur un
            chantier pour découvrir l'expertise associée.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0 border-l border-t border-slate-200">
          {ALL_REFERENCES.map((ref, i) => {
            const cover = (ref.images && ref.images[0]) || ref.image;
            return (
              <Link
                key={i}
                to={`/services/${ref.serviceSlug}`}
                data-testid={`realisation-${i}`}
                className="group relative border-r border-b border-slate-200 bg-white overflow-hidden aspect-[4/5] block"
              >
                <img
                  src={cover}
                  alt={ref.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#001a33]/95 via-[#001a33]/40 to-transparent" />
                <div className="absolute top-5 left-5 bg-[#FF5A1F] text-white px-3 py-1.5 text-[10px] uppercase tracking-[0.2em] font-semibold">
                  Chantier {ref.year}
                </div>
                <div className="absolute bottom-0 inset-x-0 p-6 md:p-7 text-white">
                  <div className="text-[10px] uppercase tracking-[0.22em] text-[#FF9A6F] font-semibold">
                    {ref.serviceTitle} · {ref.location}
                  </div>
                  <div className="mt-2 flex items-end justify-between gap-4">
                    <h3 className="font-display font-bold text-xl leading-tight">
                      {ref.title}
                    </h3>
                    <div className="w-10 h-10 border border-white/40 flex items-center justify-center shrink-0 group-hover:bg-[#FF5A1F] group-hover:border-[#FF5A1F] transition">
                      <ArrowUpRight className="w-4 h-4" />
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
